export default class CRMPermission {
  static get WorkShift () { return 'crm.work-shift' }
  static get XReport () { return 'crm.x-report' }
  static get ViewUsers () { return 'crm.users.view' }
  static get EditUsers () { return 'crm.users.edit' }
  static get LoginAsUser () { return 'crm.users.login-as' }
  static get ManageCancelOrdersRestriction () { return 'crm.users.cancel-orders.manage' }
  static get ViewCashBox () { return 'crm.cash_box.view' }
  static get AcceptConnectionAgreement () { return 'crm.connection_agreement.accept' }
  static get ConnectFilial () { return 'crm.filial.connect' }
  static get ViewNotifications () { return 'crm.notifications.view' }

  static get ViewOrders () { return 'crm.orders.view' }
  static get EditOrders () { return 'crm.orders.edit' }
  static get CreateOrderBelowMinSum () { return 'crm.orders.create-below-min-sum' }
  // Смена типа оплаты (наличные <-> терминал) завершённого заказа
  static get ChangeCompletedOrderPayment () { return 'crm.orders.change-completed-payment' }
  // Отмена и возврат по заказам прошлых рабочих смен (бэк: Order::isFromPastShift)
  static get CancelPastShiftOrders () { return 'crm.orders.cancel-past-shift' }
  static get MakeOrderPayment () { return 'crm.make-order-payment' }

  static get ViewWorkSchedule () { return 'crm.work_schedule.view' }
  static get EditWorkSchedule () { return 'crm.work_schedule.edit' }

  static get ViewCouriersMap () { return 'crm.couriers-map.view' }

  static get ViewDeliveryZones () { return 'crm.delivery-zones.view' }
  static get EditDeliveryZones () { return 'crm.delivery-zones.edit' }

  static get ViewStopList () { return 'crm.stop-list.view' }
  static get EditStopList () { return 'crm.stop-list.edit' }

  static get ViewFilialMenu () { return 'crm.filial-menu.view' }
  static get EditFilialMenu () { return 'crm.filial-menu.edit' }

  static get KitchenAssembly () { return 'kitchen.assembly' }

  static get ViewReports () { return 'crm.reports.view' }

  static get ViewSettings () { return 'crm.settings.view' }

  // Settings — per-page permissions for /settings tiles
  static get BillingPaymentDetails () { return 'crm.billing.payment-details' }

  static get ViewAdministration () { return 'crm.administration.view' }
  static get ViewAdministrationBilling () { return 'crm.administration.billing.view' }
  static get ViewAdministrationFilials () { return 'crm.administration.filials.view' }
  static get ViewAdministrationTariffs () { return 'crm.administration.tariffs.view' }

  static get LegalInfoPagesEdit () { return 'crm.legal-info-pages.edit' }

  static get Sources () { return 'crm.sources' }
  static get Connectors () { return 'crm.connectors' }

  static get KkmServer () { return 'crm.kkm-server' }
  static get PrintingFiscal () { return 'crm.printing-fiscal' }
  static get QrFeedback () { return 'crm.qr-feedback' }
  static get ReviewActions () { return 'crm.reviews-actions' }
  static get SettingsOrders () { return 'crm.settings.orders' }

  static get SiteGeneral () { return 'crm.site.general' }
  static get Seo () { return 'crm.seo' }

  static get PaymentTypes () { return 'crm.payment-types' }
  static get PaymentMethods () { return 'crm.payment-methods' }

  static get AccessRights () { return 'crm.access-rights' }

  static get SmsProvider () { return 'crm.sms-provider' }
  static get EmailProvider () { return 'crm.email-provider' }
  static get PushCertificates () { return 'crm.push-certificates' }

  static get Aggregators () { return 'crm.aggregators' }

  static get MobileApp () { return 'crm.mobile-app' }
  static get MobilePush () { return 'crm.mobile-push' }

  static get TelegramBot () { return 'crm.telegram-bot' }
  static get External () { return 'crm.external' }

  static get AcceptCollectionTransactions () { return 'crm.transactions.collection.accept' }

  static get ViewClientsStatistics () { return 'crm.clients.statistics.view' };
  static get ProhibitSendCode () { return 'crm.code.prohibit_send' };
  static get ViewStatistics () { return 'crm.stat.view' };
  static get ViewStatisticsOnMobile () { return 'crm.stat.view.mobile' };

  static get EditConnectors () { return 'crm.connectors.edit' };
  static get ViewEntities () { return 'crm.entities.view' };

  static get AddNegativePromoCodesToClients () { return 'crm.clients.promocodes.negative.add' };

  static get ViewLoginStatistics () { return 'crm.stat.login.view' }

  static get KnowledgeBaseFilialConnection () { return 'crm.knowledge-base.filial-connection' }

  static get ManagePaymentAccount () { return 'crm.payment_account.manage' };
  static get ViewPaymentAccount () { return 'crm.payment_account.view' };
  static get GiveAccessPaymentAccount () { return 'crm.payment_account.give_access' };

  static get BillingFaktLegalEntitiesManage () { return 'crm.billing.fakt-legal-entities.manage' }
}
